import Vue from 'vue'

/**
 * Basic convert number to currency
 */
Vue.filter('currency', function (value, options) {
  options = Object.assign(
    {},
    {
      symbol: '$',
      fractionCount: 2,
      cents: false,
      whole_dollars: false
    },
    options
  )

  // convert cents
  if (options.cents) {
    value /= 100
  }

  // round off extra zeros if possible
  if (options.whole_dollars && (value * 100) % 100 === 0) {
    options.fractionCount = 0
  }

  // standard format
  return options.symbol + parseFloat(value).toFixed(options.fractionCount)
})
